import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { ConnectionRequest } from '../../types/Types';

export const useSendConnectionReq = (
  options?: UseMutationOptions<ConnectionRequest, unknown, ConnectionRequest, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: ConnectionRequest) =>
      axiosInstance
        .post(getAPIURL(`/User/userId/${data.userId}/connectionId/${data.receiverId}`), data)
        .then((res) => res.data),
  });
};
